<template>
    <div class="layout">
        <Layout>
            <Header>
                <top-head></top-head>
            </Header>
            <Layout style="height:calc(100vh - 64px)">
                <Sider collapsible :collapsed-width="78" v-model="isCollapsed" style="width: 250px;min-width: 250px;max-width: 250px;flex: 0 0 250px;background-color: #323a4d">
                    <Menu ref="leftmenu" @on-select="selectItem" @on-open-change="isCollapsed=false" :active-name="activeName" theme="dark" width="auto" :accordion="true" :open-names="opennames" :class="menuitemClasses">
                        <!-- 动态菜单 -->
                        <div v-for="item in menuList">
                            <template v-if="item.type">
                                <left-menu-nav :menuList='item' :key='item.meta.order'></left-menu-nav>
                            </template>
                            <template v-else>
                                <div v-for="main in item.children">
                                    <menu-item :name="main.meta.order" :to="main.path" :key='main.meta.order'>
                                        <Icon :type="main.type" />
                                        <span>{{ main.meta.title }}</span>
                                    </menu-item>
                                </div>
                            </template>
                        </div>
                    </Menu>
                </Sider>
                <Layout :style="{padding: '0 10px 10px',background:'#fff'}">
                    <router-view></router-view>
                </Layout>
            </Layout>
        </Layout>
    </div>
</template>
<script>
    import leftMenuNav from './leftMenuNav'
    import TopHead from './TopHead'
    export default {
        components: {TopHead,leftMenuNav},
        data () {
            return {
                opennames:[],
                activeName:'',
                submenuname:[],
                isCollapsed: false
            }
        },
        created(){
            // 多级菜单 刷新收缩问题
            this.syncActiveMenu();
        },
        watch:{
            // 路由变化时同步左侧菜单高亮（同一 Main 实例内切换路由时 created 不会再次触发，
            // 例如从 AI 可用性面板跳转到工单详情，需要在此处重新计算高亮项）
            '$route'(){
                this.syncActiveMenu();
            },
            // 收缩
            isCollapsed(val){
                if(val){
                    this.opennames=[];
                    this.$nextTick(()=>{
                        this.$refs.leftmenu.updateOpened();
                    });
                }
            }
        },
        computed: {
            menuitemClasses: function () {
                return [
                    'menu-item',this.isCollapsed ? 'collapsed-menu' : ''
                ]
            },
            // 菜单栏
            menuList() {
                return global.antRouter;
            }
        },
        methods:{
            // 在实际渲染的菜单数据（global.antRouter，来自后端）中按路径递归查找对应节点的 order。
            // 菜单展示与高亮必须基于同一份后端数据，否则与本地 router 的 meta.order 不一致时会高亮错位。
            findMenuOrderByPath:function(list, path){
                if(!Array.isArray(list)) return null;
                for(var i=0;i<list.length;i++){
                    var node=list[i];
                    if(node.path===path && node.meta && node.meta.order){
                        return node.meta.order;
                    }
                    if(node.children && node.children.length){
                        var found=this.findMenuOrderByPath(node.children, path);
                        if(found) return found;
                    }
                }
                return null;
            },
            // 同步左侧菜单高亮与展开项。
            // 优先用后端菜单中与当前路径匹配的节点 order（保证与菜单展示一致）；
            // 路径不在菜单中的页面（如工单详情等二级详情页）回退到本地路由 meta.order。
            syncActiveMenu:function(){
                var order = this.findMenuOrderByPath(this.menuList, this.$route.path);
                if(!order && this.$route.meta && this.$route.meta.order){
                    order = this.$route.meta.order;
                }
                if(order){
                    // 当前高亮
                    this.activeName = order;
                    // 每次重新计算前重置展开项，避免路由切换时 push 累积重复项
                    this.opennames=[];
                    this.submenuname=order.split('-');
                    // 顶级为 "0" 的是无子菜单的扁平菜单项，本身无父级 Submenu，无需展开。
                    // 其余菜单按任意层级展开当前项的全部祖先 Submenu：
                    // 原实现按 2~5 级硬编码，一旦命中菜单层级超出该范围 opennames 会为空，
                    // 触发 updateOpened 时会把整棵父菜单收起。这里改为按 order 段数动态构建祖先链。
                    if(this.submenuname.length>=2&&this.submenuname[0]!=="0"){
                        for(var i=1;i<this.submenuname.length;i++){
                            this.opennames.push(this.submenuname.slice(0,i).join('-'));
                        }
                    }
                    // 菜单组件需在下一帧根据最新 activeName / opennames 重新渲染高亮态
                    this.$nextTick(()=>{
                        if(this.$refs.leftmenu){
                            this.$refs.leftmenu.updateActiveName();
                            this.$refs.leftmenu.updateOpened();
                        }
                    });
                }
            },
            selectItem:function(name){
                this.isCollapsed=false;
                if(name.startsWith('0')){
                    this.opennames=[];
                    this.$nextTick(()=>{
                        this.$refs.leftmenu.updateOpened();
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .layout{
        background: #f5f7f9;
        position: relative;
        overflow: hidden;
    }
    .layout-con{
        height: 100%;
        width: 100%;
    }
    .menu-item span{
        display: inline-block;
        overflow: hidden;
        width: 144px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
    }
    .menu-item i{
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 16px;
    }
    .collapsed-menu span{
        width: 0px;
        transition: width .2s ease;
    }
    .collapsed-menu>>>.ivu-icon-ios-arrow-down {
        display: none;
    }
    .collapsed-menu i{
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 22px;
    }
    .ivu-layout-sider
    {
        overflow-y: auto;
    }
        /* 滚动条 */
    .ivu-layout-sider::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .ivu-layout-sider::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .ivu-layout-sider::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .ivu-layout-sider::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .ivu-layout-sider>>>.ivu-layout-sider-trigger
    {
        background-color: #323a4d;
        display: none;
    }
    .ivu-layout-sider>>>.ivu-menu-dark
    {
        background-color: #2f374a;
    }
    .ivu-layout-sider>>>.ivu-menu
    {
        background-color: #2f374a;
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu){
        color:#fff;
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):hover, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu):hover{
        background-color: #2d8cf0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Main.vue